import Typetester from './Typetester.svelte';

const testers = document.querySelectorAll('[data-type-tester]');

testers.forEach(function (tester) {
  new Typetester({
    target: tester,
    props: {
      ...tester.dataset,
    },
  });
});
